module.exports = __webpack_public_path__ + "img/s.836d79ed.jpg";